// extracted by mini-css-extract-plugin
export default {"roundImage":"RoundImage_roundImage__tP+HA","avatar":"RoundImage_avatar__eX7a4","rowAvatar":"RoundImage_rowAvatar__yad3Y","big":"RoundImage_big__KkxTS"};